import { makeActionCreator } from '../../../config/store/utils';
import { readParquet } from '../../../services/productivityService'; // Assuming the function is in this service file

// Action Types
export const GET_PTO_REPORT = 'GET_PTO_REPORT';
export const GET_PTO_REPORT_ERROR = 'GET_PTO_REPORT_ERROR';
export const GET_PTO_REPORT_SUCCESS = 'GET_PTO_REPORT_SUCCESS';

// Action Creators
export const onGetPtoReport = makeActionCreator(GET_PTO_REPORT);
export const onGetPtoReportError = makeActionCreator(
  GET_PTO_REPORT_ERROR,
  'payload'
);
export const onGetPtoReportSuccess = makeActionCreator(
  GET_PTO_REPORT_SUCCESS,
  'payload'
);

// Async action to fetch the Parquet data
export const onGetPtoReportThunk = ({ year, month, day }) => async dispatch => {
  dispatch(onGetPtoReport()); // Start loading
  try {
    const type = 'diferencia_pto'; // Adjust the type if necessary
    const response = await readParquet({ type, year, month, day });
    const data = JSON.parse(response.data).map((item, index) => {
      return {
        ...item,
        id: `${index + 1}`,
      };
    });
    dispatch(onGetPtoReportSuccess({ data: data })); // Dispatch success with the data
  } catch (error) {
    dispatch(
      onGetPtoReportError({
        error: error.message || 'Error fetching data',
      })
    ); // Dispatch error
  }
};
